import maxceiEmblem from "@assets/images/maxcei-emblem.png";
import { Box, Text } from "@saleor/macaw-ui-next";

export const MountingPoint = () => {
  return (
    <Box display="flex" gap={3} paddingX={4} paddingY={5} alignItems="center">
      <Box as="img" src={maxceiEmblem} alt="MAXCEI" width={8} height={8} />
      <Text size={3} fontWeight="bold">
        MAXCEI
      </Text>
    </Box>
  );
};
